import * as React from 'react';
import { SVGProps } from 'react';

const SvgAndroidIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.776 14.031c-.476 0-.864-.371-.864-.828 0-.456.388-.827.864-.827.477 0 .865.371.865.827 0 .457-.388.828-.864.828Zm-9.552 0c-.477 0-.865-.371-.865-.828 0-.456.388-.827.865-.827.476 0 .864.371.864.827 0 .457-.388.828-.864.828Zm9.863-4.984 1.727-2.865a.337.337 0 0 0-.132-.47.369.369 0 0 0-.49.126l-1.75 2.9A11.065 11.065 0 0 0 12 7.829c-1.603 0-3.105.326-4.442.91l-1.75-2.9a.369.369 0 0 0-.49-.126.336.336 0 0 0-.132.47l1.728 2.865c-2.967 1.544-4.995 4.42-5.292 7.816h20.756c-.297-3.397-2.326-6.272-5.291-7.816Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgAndroidIcon;
